import { useEffect } from 'react'
import { getDateReceivedFilterType, sevenDaysAgo, today } from '../lib'
import { useFilters } from './use-filters'

export const useSyncDateReceivedFilterType = () => {
  const { filters, setFilters, dateReceivedFilterType, setDateReceivedFilterType } = useFilters()

  useEffect(() => {
    setDateReceivedFilterType(getDateReceivedFilterType(filters.dateFrom, filters.dateTo))
  }, [filters.dateFrom, filters.dateTo, setDateReceivedFilterType])

  useEffect(() => {
    switch (dateReceivedFilterType) {
      case 'today':
        setFilters({ dateFrom: today, dateTo: today })
        break
      case 'last7days':
        setFilters({ dateFrom: sevenDaysAgo, dateTo: today })
        break
      case 'custom':
        setFilters({ dateFrom: filters.dateFrom, dateTo: filters.dateTo })
        break
      default:
        setFilters({ dateFrom: '', dateTo: '' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateReceivedFilterType])
}
